import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { LicenceApplicationService } from '../shared/services/licence-application.service';
import { DataService } from '../shared/services/data.service';
import { TranslateDirective } from '../shared/translate.directive';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoaderService } from '../shared/services/loader.service';

@Component({
  selector: 'app-confirm-payment',
  standalone: true,
  imports: [TranslateDirective, CommonModule, FormsModule],
  templateUrl: './confirm-payment.component.html',
  styleUrl: './confirm-payment.component.less'
})
export class ConfirmPaymentComponent {
  constructor(private router: Router, private licenseService: LicenceApplicationService, private dataService: DataService,
    private activatedRoute: ActivatedRoute, public myLoaderService: LoaderService) {
    activatedRoute.queryParams.subscribe((params) => {
      this.id = params['id']
    });
  }

  id: any;
  appModel: any;
  hasErrors = false;
  errorsMessages: any;

  ngOnInit() {    
    this.appModel = this.dataService.getData();   
    this.idModel.VehicleIds = this.appModel.Vehicles.map((vehicle: { VehicleId: any; }) => vehicle.VehicleId);
    this.idModel.Price = this.appModel.Price;
    this.idModel.Months = this.appModel.Months;
    this.idModel.DateSelected = this.appModel.DateSelected;
    
  }

  message: any;
  idModel: any = {
    Id: null,
  }

  goToDashboard() {
    this.router.navigate(['/app-list']);
  }

  getApplicationDetalis() {
    this.idModel.Id = this.id;
    this.licenseService.getApplicationDetalis(this.idModel).subscribe((res: any) => {
      this.appModel = res;
      this.dataService.setData(res);
      this.idModel.VehicleIds = this.appModel.Vehicles.map((vehicle: { VehicleId: any; }) => vehicle.VehicleId);
      this.idModel.Price = this.appModel.Price;
      this.idModel.Months = this.appModel.Months;
    })
  }

  pay() {
    this.idModel.Id = this.id;
    this.licenseService.pay(this.idModel).subscribe((res: any) => {     
      window.location.href = res.RedirectUrl;
    },

      error => {      
        this.hasErrors = true;
        this.errorsMessages = error.error.errors[0].Errors[0];
      })

  }
}
